import React from "react";
import { Box, ToggleButtonGroup, ToggleButton } from "@mui/material";
import CalendarViewWeekIcon from "@mui/icons-material/CalendarViewWeek";
import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
import Langs from "../../../../../app/lang/langs";
import { ORANGE, TRANSITION_SMOOTH } from "../constants";

export default function ViewToggle({ selectedView, onViewChange }) {
  const handleChange = (_event, newView) => {
    if (newView !== null) {
      onViewChange(newView);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        // Left-aligned, not centred: the toggle is a control, and on a phone every other
        // control in this bar starts at the left margin. Centring it left it floating with
        // nothing either side, and out of line with the rows beneath it.
        justifyContent: "flex-start",
        px: 1.5,
        pb: 1,
      }}
    >
      <ToggleButtonGroup
        value={selectedView}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          "& .MuiToggleButtonGroup-grouped": {
            border: "1px solid rgba(0,0,0,0.08)",
            borderRadius: "10px",
            mx: 0.5,
            px: 2,
            py: 0.5,
            minHeight: 36,
            minWidth: 80,
            fontSize: "0.8rem",
            fontWeight: 600,
            textTransform: "none",
            transition: TRANSITION_SMOOTH,
            "&:hover": {
              backgroundColor: "rgba(255,144,21,0.06)",
            },
            "&.Mui-selected": {
              backgroundColor: ORANGE,
              color: "#fff",
              fontWeight: 700,
              borderColor: ORANGE,
              boxShadow: "0 2px 8px rgba(255,144,21,0.3)",
              "&:hover": {
                backgroundColor: ORANGE,
              },
            },
            "&:not(:first-of-type)": {
              borderLeft: "1px solid rgba(0,0,0,0.08)",
              borderRadius: "10px",
            },
            "&:first-of-type": {
              borderRadius: "10px",
            },
          },
        }}
      >
        <ToggleButton value="WEEKLY" aria-label="weekly view">
          <CalendarViewWeekIcon sx={{ fontSize: "1rem", mr: 0.5 }} />
          <Langs str="Week" />
        </ToggleButton>
        <ToggleButton value="MONTHLY" aria-label="monthly view">
          <CalendarViewMonthIcon sx={{ fontSize: "1rem", mr: 0.5 }} />
          <Langs str="Month" />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
